// extracted by mini-css-extract-plugin
module.exports = {"OurAwards":"styles_OurAwards__gNWq8","img":"styles_img__giRSk","bg_1":"styles_bg_1__tlwXm","bg_2":"styles_bg_2__s4U_l","height":"styles_height__yXoM_"};